export interface ApiErrorViolation {
  field?: string
  reason?: string
  args?: Record<string, unknown>
}

export interface ApiErrorPayload {
  timestamp?: string
  status?: number
  error?: string
  reason?: string
  args?: Record<string, unknown>
  violations?: ApiErrorViolation[]
  message?: string
  path?: string
  correlationId?: string
}

export const AuthHttpStatus = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  GONE: 410,
  UNPROCESSABLE: 422,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500,
} as const

export const AuthErrorCode = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  USER_BLOCKED: 'USER_BLOCKED',
  USER_INACTIVE: 'USER_INACTIVE',
  USER_PENDING_ACTIVATION: 'USER_PENDING_ACTIVATION',
  PASSWORD_TOO_WEAK: 'PASSWORD_TOO_WEAK',
  PASSWORD_REUSED: 'PASSWORD_REUSED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  IP_RATE_LIMIT_EXCEEDED: 'IP_RATE_LIMIT_EXCEEDED',
} as const

export type AuthErrorCodeName =
  (typeof AuthErrorCode)[keyof typeof AuthErrorCode]

export const AuthErrorReason = {
  INVALID_OR_EXPIRED_TOKEN: 'accesscontrol.account.invalid_or_expired_token',
  PASSWORD_POLICY_VIOLATED: 'accesscontrol.user.password_policy_violated',
  INVALID_CREDENTIALS: 'accesscontrol.auth.invalid_credentials',
  LOGIN_RATE_LIMIT: 'accesscontrol.auth.login_attempt_limit_exceeded',
  CURRENT_PASSWORD_MISMATCH: 'accesscontrol.user.current_password_mismatch',
} as const

export type AuthErrorReasonName =
  (typeof AuthErrorReason)[keyof typeof AuthErrorReason]
